import axios, { AxiosError } from "axios";
import { useQuery, UseQueryResult } from "react-query";
import McmSegmentPreviewRequest from "../request/McmSegmentPreviewRequest";
import McmSegmentPreviewResponse from "../model/McmSegmentPreviewResponse";

export const McmSegmentPreviewApiService = async (
  request: McmSegmentPreviewRequest,
): Promise<McmSegmentPreviewResponse> => {
  const { data } = await axios.post(
    "/mcm-segments/preview-rules/",
    request,
  );
  return data;
};

const useMcmSegmentPreviewApiService = (
  request: McmSegmentPreviewRequest,
  enabled = true,
): UseQueryResult<McmSegmentPreviewResponse, AxiosError> =>
  useQuery<McmSegmentPreviewResponse, AxiosError>(
    ["McmSegmentPreviewApiService", JSON.stringify(request)],
    () => McmSegmentPreviewApiService(request),
    {
      enabled,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: 0,
    },
  );

export default useMcmSegmentPreviewApiService;
